import React from "react";

export const Button = (props) => {
  const {
    btnType = "button",
    btnCategory = "primary",
    btnName,
    isDisabled = false,
    btnCls = "",
    btnStyle = {},
    ...rest
  } = props;
  let customStyle = {
    ...btnStyle,
  };

  const buttonStyle = {
    primary: "bg-background-primary-main text-white border-none hover:bg-background-primary-dark",
    secondary: "border border-background-primary-main text-font-primary-main hover:bg-background-primary-light",
    outline: "bg-gray-200 text-gray-800 hover:bg-gray-100 text-black bg-white",
    ghost: "text-background-primary-main border-none"
  };
  // Normalize some common variant names used across the app.
  const variantMap = {
    contained: "primary",
    text: "ghost",
  };
  const category = variantMap[btnCategory] || btnCategory;
  
  return (
    <button
      disabled={isDisabled}
      type={btnType}
       className={`flex items-center justify-center rounded-md p-2 text-sm font-medium  cursor-pointer
           ${isDisabled ? "cursor-not-allowed opacity-50" : ""}
         ${buttonStyle[category] || buttonStyle["primary"]}
           ${btnCls}
        `}
      style={customStyle}
      {...rest}
    >
      {btnName}
    </button>
  );
};
